// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Baustelle, BaustelleDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateBaustelle(): (
  id: string,
  requestBody: BaustelleDaten
) => Promise<Baustelle> {
  const getAPI = useGetApi();
  return useCallback(
    async (id, requestBody) =>
      (await getAPI()).baustellen.updateBaustelle({ id, requestBody }),
    [getAPI]
  );
}
